import { MenuItemProps, useRuntimeEnvRolesIncludes } from "@harea/component";
import clsx from "clsx";
import { useLeftSideBarMenu } from "components/layout/hooks/useLeftSideBarMenu";
import { NavItem } from "components/SidebarNavItem";
import _ from "lodash";
import { useMemo } from "react";

function mapFn(item: MenuItemProps): NavItem {
  return {
    icon: typeof item.startIcon === "string" ? <i className={clsx("fa-solid", item.startIcon)}></i> : item.startIcon,
    label: item.label!,
    to: item.link ?? item.externalLink,
    children: item.items
      ?.filter((child): child is MenuItemProps => child !== undefined)
      .map(mapFn),
  };
}

export function useSidebarNavigation(): NavItem[] {
  const roleIncludes = useRuntimeEnvRolesIncludes();
  const menuItems = useLeftSideBarMenu();

  const transformedMenuItems = useMemo(() => {
    return menuItems
      .map((menu) => {
        return {
          ...menu,
          items: menu.items?.filter(
            (item) =>
              _.isEmpty(item?.roles) ||
              !!item?.roles?.some((role: string) => roleIncludes(role)),
          ),
        };
      })
      // .filter((item) => !_.isEmpty(item.items))
      .map((menu) => mapFn(menu));
  }, [roleIncludes]);

  return transformedMenuItems;
}
